// LEGACY: Uses SCSS with CSS modules. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';
import classNames from 'classnames';
import Template from '../template';

import styles from './index.module.scss';
import useMobileBlockerProps from 'app/error-pages/mobile-blocker/useMobileBlockerProps';

const TEMPLATE_PROPS = {
  title: 'Use desktop browser',
  message: 'We’re gonna need a bigger boat.',
  SupportingText,
};

function SupportingText() {
  return (
    <p>The MetaRouter UI is best experienced on a desktop browser. Please use a screen width greater that 975 px.</p>
  );
}

export default function MrMobileBlocker() {
  const { isScreenHidden, button } = useMobileBlockerProps();

  if (isScreenHidden) {
    return null;
  }

  return (
    <div className={classNames(styles.mobileBlocker, styles.overlay)}>
      <Template {...TEMPLATE_PROPS} button={button} />
    </div>
  );
}
